






















































import Vue from 'vue'
import { UpdateFileDto } from '@/service-proxies/app-v2/dnc.service-proxies'
import { getFileContentOrDownload } from './viewdetail'
import { FileServiceProxy, } from '@/service-proxies/app-v2/dnc.service-proxies'
import { previewMode} from '@/utils/commonDef'
import { OssFile, ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
const resourceService = new ResourceServiceProxy()

const fileservice = new FileServiceProxy()
export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    parentid:{
      type: String,
      default: '0'
    },
    footer: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      message: '',
      loading: false,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 }
      },
      encodeType: 'UTF-8',
      encodingTypes: ['ANSI', 'UTF-16 LE', 'UTF-16 BE', 'UTF-8', 'GBK', 'Big5', ' Shift-JIS'],
      type: 1,
      canEditSuffix: previewMode.text,
      imageSuffix: previewMode.image,
      content: null
    }
  },
  watch: {
    'item.id':{
      handler(){
        if(!this.item.id){
          return
        }
        const name = this.item.name
        if(name && name.indexOf('.') != -1){
          var a = /.*\.(.*)$/
          const suffix = a.exec(name)[1]
          if(this.isImage(suffix)){
            this.type = 2
            this.viewDetail()
          } else if (this.canEdit(name)) {
            this.type = 1
            this.viewDetail()
          } else if (suffix === 'pdf'){
            this.getPdfUrl()
          } else {
            // this.message = ''
            // 匹配不到已存在格式的文件直接以nc格式打开
            this.type = 1
            this.viewDetail()
          }
        } else if(name && name.indexOf('.') === -1){
          this.type = 1
          this.viewDetail()
        }
      }
    }
  },
  methods: {
    onClose(){
      this.form.resetFields()
      this.encodeType = 'UTF-8'
      this.$emit('close',false)
    },
    save(){
      this.form.validateFields(async (err,values) => {
        if (!err) {

          let newFile = new File([new Blob([values.message])], values.name)
          let bladeFile = await resourceService.putFileUsingPOST({fileName: this.item.name, data: newFile})
          let ossFile = await (await resourceService.statFileUsingGET(bladeFile.data.name)).data

          const value = new UpdateFileDto({
            ossFile: ossFile as OssFile,
            fileId: this.item.id
          })
          fileservice.updateFile(value).then(res =>{
            this.$message.success(this.$t('page_my_document_updatesucess'))
            this.form.resetFields()
            this.encodeType = 'UTF-8'
            this.$emit('close',true)
          })
        }
      });
    },
    changeEdit(){
      this.$emit('change')
    },
    getPdfUrl(): void{
      const file = this.item
      resourceService.statFileUsingGET(file.objectKey).then(res=>{
        this.content = res.data.link
      })
    },
    canEdit(name){
      let bool = false
      if(name && name.indexOf('.') != -1){
        const a = /.*\.(.*)$/
        const suffix = a.exec(name)[1]
        bool = this.canEditSuffix.includes(suffix.toLowerCase())
      } else {
        bool = true
      }
      return bool
    },
    isImage(suffix){
      let bool = false
      if(suffix){
        bool = this.imageSuffix.includes(suffix.toLowerCase())
      }
      return bool
    },

    viewDetail(){
      this.loading = true
      const file = this.item
      console.log(6666,file.objectKey)
      getFileContentOrDownload(file.name,file.objectKey,this.type,this.encodeType, file.contentType).subscribe(res =>{
        this.message = res
        this.loading = false
      })
    },
    selectType(e){
      this.encodeType = e
      this.viewDetail()
    }
  }
})
